export default __webpack_public_path__ + "static/media/G89A3660_tn.577070e4.jpg";